import { render, staticRenderFns } from "./UsageDevelopment.vue?vue&type=template&id=8298d1b4&"
import script from "./UsageDevelopment.vue?vue&type=script&lang=js&"
export * from "./UsageDevelopment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports